function initializeDeliveryDate() {
  const storedPincodeResponse = localStorage.getItem("pincodeResponse");
  if (storedPincodeResponse) {
    const deliveryDateContainers = document.querySelectorAll(".itemComponents-base-deliveryDateContainer");
    const highlightedMessages = document.querySelectorAll(".itemComponents-base-highlightedMessage.itemComponents-base-speed11Highlight");

    if (deliveryDateContainers.length > 0 && highlightedMessages.length > 0) {
      const eddData = JSON.parse(storedPincodeResponse);
      displaySuccess(eddData, highlightedMessages);

      // Show the delivery date containers
      deliveryDateContainers.forEach((container) => {
        container.classList.remove("hidden");
      });
    }
  }
}

function displaySuccess(eddData, targetElements) {
  const { predicted_sla_min, predicted_sla_max } = eddData;

  if (predicted_sla_min !== undefined && predicted_sla_max !== undefined) {
    const currentDate = new Date();
    const minDate = new Date(currentDate);
    const maxDate = new Date(currentDate);

    minDate.setDate(currentDate.getDate() + predicted_sla_min);
    maxDate.setDate(currentDate.getDate() + predicted_sla_max);

    const minDateStr = minDate.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
    const maxDateStr = maxDate.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

    const successMessage = `Get it between ${minDateStr} and ${maxDateStr}`;

    // Update all elements in the NodeList
    targetElements.forEach((element) => {
      element.innerHTML = successMessage;
    });
  } else {
    
    targetElements.forEach((element) => {
      element.textContent = "Delivery date not available";
    });
  
  }
}
